import { defineMessages } from 'react-intl';

export const scope = 'axjorecycling.returnsystem.sendPushMessage';

export default defineMessages({

    header: {
        id: `${scope}.pageTitle`,
        defaultMessage: 'Send push message to all users of the app',
    },
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Title',
    },
    body: {
        id: `${scope}.body`,
        defaultMessage: 'Body',
    },
    url: {
        id: `${scope}.url`,
        defaultMessage: 'URL',
    },
    send: {
        id: `${scope}.send`,
        defaultMessage: 'Send push notification',
    },
    success: {
        id: `${scope}.success`,
        defaultMessage: 'Push notification sent successfully',
    },
    error: {
        id: `${scope}.error`,
        defaultMessage: 'Error sending push notification',
    },
})